import React, { useState } from 'react';
import { App, Form, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { changePassword } from '../api/auth';
import { getApiErrorMessage } from '../utils/apiError';
import AuthLayout from '../components/AuthLayout';
import { WarnIcon, LockIcon } from '../components/AuthIcons';

export default function ForceChangePassword() {
  const { message, notification } = App.useApp();
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [pwdForm] = Form.useForm();
  const [pwdLoading, setPwdLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setPwdLoading(true);
      const v = await pwdForm.validateFields();
      await changePassword({ current_password: v.current_password, new_password: v.new_password });

      const nextUser = { ...(user || {}), must_change_password: false };
      localStorage.setItem('user', JSON.stringify(nextUser));
      setUser(nextUser);

      message.success('Mot de passe mis à jour.');

      const roleToPath = { admin: '/admin', supervisor: '/supervisor', student: '/student' };
      navigate(roleToPath[nextUser.role] || '/login', { replace: true });
    } catch (e) {
      notification.error({ message: getApiErrorMessage(e, 'Changement de mot de passe échoué. Vérifiez le mot de passe actuel.'), placement: 'topRight' });
    } finally {
      setPwdLoading(false);
    }
  };

  return (
    <AuthLayout isSingleColumn>
      <div>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: '0 0 24px', textAlign: 'center', fontSize: 20, fontWeight: 700, color: 'var(--auth-primary-dark)' }}>Sécurité</h2>
        </div>

        <div className="card">
          <div className="info-bar warn-bar">
            {WarnIcon}
            <div>
              <div className="info-bar-title">Changement obligatoire</div>
              <div className="info-bar-desc">Votre compte utilise un mot de passe temporaire. Vous devez le modifier.</div>
            </div>
          </div>
          <div className="card-inner">
            <Form form={pwdForm} onFinish={onSubmit} layout="vertical" requiredMark={false}>
              
              <div className="field">
                <label>Mot de passe temporaire <span>*</span></label>
                <div className="input-wrap">
                  {LockIcon}
                  <Form.Item name="current_password" noStyle rules={[{ required: true, message: 'Mot de passe temporaire requis' }]}>
                    <Input.Password placeholder="••••••••" bordered={false} />
                  </Form.Item>
                </div>
              </div>

              <div className="field">
                <label>Nouveau mot de passe <span>*</span></label>
                <div className="input-wrap">
                  {LockIcon}
                  <Form.Item name="new_password" noStyle rules={[{ required: true, min: 8, message: 'Minimum 6 caractères' }]}>
                    <Input.Password placeholder="••••••••" bordered={false} />
                  </Form.Item>
                </div>
              </div>

              <div className="field">
                <label>Confirmer le mot de passe <span>*</span></label>
                <div className="input-wrap">
                  {LockIcon}
                  <Form.Item
                    name="confirm_password"
                    noStyle
                    dependencies={['new_password']}
                    rules={[
                      { required: true, message: 'Veuillez confirmer' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('new_password') === value) return Promise.resolve();
                          return Promise.reject(new Error('Les mots de passe ne correspondent pas'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="••••••••" bordered={false} />
                  </Form.Item>
                </div>
              </div>

              <button className="btn-primary" type="submit" disabled={pwdLoading}>
                {pwdLoading ? 'Mise à jour...' : 'Mettre à jour'}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

